import gql from 'graphql-tag';

import { Query, Mutation } from 'core/index';

import { CONTENT_FIELDS } from 'apps/content/gql';

export const STORY_LIST_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment storyListFields on Story {
    id
    slug
    avatar {
      id
      path
      url
      completed
    }
    title
    readLength
    lastUpdated
    dateCreated
    content {
      ...contentFields
    }
    creatorProfile {
      id
      username
    }
    space {
      id
      spaceType
      content {
        id
        slug
      }
    }
    tags {
      id
      name
    }
    comments {
      totalCount
    }
  }
`;

export const STORY_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment storyFields on Story {
    id
    canUpdate
    canDelete
    slug
    avatar {
      id
      path
      url
      filename
      completed
    }
    title
    readLength
    lastUpdated
    dateCreated
    content {
      ...contentFields
    }
    creatorProfile {
      id
      username
      preferredName
      fullName
      bio
      avatar {
        id
        path
        url
      }
      content {
        ...contentFields
      }
    }
    space {
      id
      spaceType
      content {
        id
        slug
      }
    }
    inSpace {
      id
    }
    tags {
      id
      name
    }
    comments {
      totalCount
    }
  }
`;

export const STORY_CONNECTION_FIELDS = gql`
  ${STORY_LIST_FIELDS}
  fragment storyConnectionFields on StoryConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ...storyListFields
        bodySnippet
      }
    }
  }
`;

export const STORY_MUTATION = gql`
  ${STORY_FIELDS}
  mutation Story($storyInput: StoryInput) {
    story(storyData: $storyInput) {
      story {
        ...storyFields
        bodySnippet
        body
      }
    }
  }
`;
export class StoryMutation extends Mutation {
  static conf = {
    GQL: STORY_MUTATION,
    inputName: 'storyInput',
  };
}

export const STORY = gql`
  ${STORY_FIELDS}
  query Story($space: String, $slug: String) {
    story(space: $space, slug: $slug) {
      ...storyFields
      body
      bodySnippet
    }
  }
`;
export class StoryQuery extends Query {
  static conf = {
    GQL: STORY,
    varNames: ['space', 'slug'],
    resultPath: 'story',
  };
}

export const STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query HomeStories(
    $batchSize: Int
    $cursor: String
    $sortBy: String
    $filterBy: [[String!]]
  ) {
    stories(
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
      filterBy: $filterBy
    ) {
      ...storyConnectionFields
    }
  }
`;
export class StoriesQuery extends Query {
  static conf = {
    GQL: STORIES,
    varNames: ['batchSize', 'cursor', 'sortBy', 'filterBy'],
    resultPath: 'stories',
  };
}

export const PROFILE_STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query ProfileStories(
    $username: String!
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    profile(username: $username) {
      id
      stories(first: $batchSize, after: $cursor, sortBy: $sortBy) {
        ...storyConnectionFields
      }
    }
  }
`;
export class ProfileStoriesQuery extends Query {
  static conf = {
    GQL: PROFILE_STORIES,
    varNames: ['username', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'profile.stories',
  };
}

export const INITIATIVE_STORIES = gql`
  ${STORY_CONNECTION_FIELDS}
  query InitiativeStories(
    $slug: String
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    initiative(slug: $slug) {
      id
      stories(first: $batchSize, after: $cursor, sortBy: $sortBy) {
        ...storyConnectionFields
      }
    }
  }
`;
export class InitiativeStoriesQuery extends Query {
  static conf = {
    GQL: INITIATIVE_STORIES,
    varNames: ['slug', 'cursor', 'sortBy', 'batchSize'],
    resultPath: 'initiative.stories',
  };
}
